import api from './client';
export const getPriorityList = () => api.get('/chat-ai/priority-list').then(r => r.data);
export const getCaseProfile = (recordId) => api.get(`/chat-ai/case-profile/${recordId}`).then(r => r.data);
export const sendMessage = (body) => api.post('/chat-ai/message', body).then(r => r.data);
export const createRecord = (body) => api.post('/chat-ai/create-record', body).then(r => r.data);
export const updateRecord = (body) => api.post('/chat-ai/update-record', body).then(r => r.data);
export const executeTransition = (body) => api.post('/chat-ai/transition', body).then(r => r.data);
export const executeAction = (actionId, confirmed) => api.post(`/ai-chat/actions/${actionId}`, { confirmed }).then(r => r.data);
export const login = (email, password) => api.post('/auth/login', { email, password }).then(r => r.data);
export const uploadDocument = (formData) => api.post('/chat-ai/upload-document', formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(r => r.data);
export const confirmDocumentCategory = (body) => api.post('/chat-ai/confirm-document-category', body).then(r => r.data);
export const saveDocumentTags = (body) => api.post('/chat-ai/save-document-tags', body).then(r => r.data);
export const getHistory = (recordId, params) => api.get(`/chat-ai/history/${recordId}`, { params }).then(r => r.data);
export const searchHistory = (recordId, q) => api.get(`/chat-ai/history/${recordId}/search`, { params: { q } }).then(r => r.data);
export const getRecordFiles = (recordId) => api.get(`/chat-ai/record-files/${recordId}`).then(r => r.data);
export const deleteDocument = (fileId) => api.delete(`/chat-ai/delete-document/${fileId}`).then(r => r.data);
export const createTask = (body) => api.post('/chat-ai/create-task', body).then(r => r.data);
export const logAction = (body) => api.post('/chat-ai/log-action', body).then(r => r.data);
export const updateTask = (body) => api.post('/chat-ai/update-task', body).then(r => r.data);
export const getTaskNotes = (taskId) => api.get(`/chat-ai/task-notes/${taskId}`).then(r => r.data);
export const getTaskHistory = (taskId) => api.get(`/chat-ai/task-history/${taskId}`).then(r => r.data);
export const createIntake = (body) => api.post('/chat-ai/create-intake', body).then(r => r.data);
export const getAttention = () => api.get('/chat-ai/attention').then(r => r.data);
export const clearAttention = (recordId) => api.post(`/chat-ai/attention/clear/${recordId}`).then(r => r.data);
export const sendSMS = (data) => api.post('/chat-ai/send-sms', data).then(r => r.data);
export const initiateCall = (data) => api.post('/chat-ai/initiate-call', data).then(r => r.data);
export const markCommRead = (commId) =>
  fetch(`/api/chat-ai/comms/mark-read/${commId}`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${localStorage.getItem('lf_token')}` }
  });
export const generateDocument = (templateId, recordId) =>
  api.post('/chat-ai/generate-document', { templateId, recordId }).then(r => r.data);
export const getUiPreferences = () =>
  api.get('/chat-ai/ui-preferences').then(r => r.data?.preferences || {});
export const saveUiPreference = (updates) =>
  api.put('/chat-ai/ui-preferences', updates).then(r => r.data?.preferences || {});
// Teams Part 3B — current user's team list, used by the CREATE_RECORD confirm
// card team picker (and any future team-aware UI in chat-frontend).
export const getMyTeams = () => api.get('/users/me/teams').then(r => r.data?.teams || []);

// Notifications (Teams Part 3C inbox API)
export const getNotifications = (params = {}) =>
  api.get('/notifications', { params }).then(r => r.data?.notifications || []);

export const getUnreadCount = () =>
  api.get('/notifications/unread-count').then(r => r.data?.count ?? 0);

export const markNotificationsRead = (ids) =>
  api.post('/notifications/mark-read', { ids }).then(r => r.data);

export const markAllNotificationsRead = () =>
  api.post('/notifications/mark-all-read').then(r => r.data);

export const dismissNotifications = (ids) =>
  api.post('/notifications/dismiss', { ids }).then(r => r.data);

// Per-record team access (Part 2C CRUD endpoints)
export const getRecordTeamAccess = (recordId) =>
  api.get(`/records/${recordId}/team-access`).then(r => r.data);

export const grantRecordTeamAccess = (recordId, body) =>
  api.post(`/records/${recordId}/team-access`, body).then(r => r.data);

export const revokeRecordTeamAccess = (recordId, teamId, source) =>
  api.delete(`/records/${recordId}/team-access/${teamId}`, { data: { source } }).then(r => r.data);

// Tenant team list — open to all tenant members per Part 3A
export const listTenantTeams = () =>
  api.get('/admin/teams').then(r => r.data?.teams || []);
